"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCertificate02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 1C3.247 1 2 2.544 2 4.222v15.556C2 21.456 3.247 23 5 23h14c1.753 0 3-1.544 3-3.222V4.222C22 2.544 20.753 1 19 1H5Zm2 13a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H7Zm2 3.5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Zm.254-11.563c.877-.714 2.044-.504 2.744.275.7-.78 1.851-.981 2.743-.275.892.706 1 1.906.312 2.75-.389.476-1.313 1.311-2.043 1.948-.347.302-.52.454-.73.515a1.032 1.032 0 0 1-.565 0c-.21-.062-.383-.213-.73-.515-.73-.637-1.654-1.472-2.043-1.948-.688-.844-.565-2.037.312-2.75Z", fill: "currentColor" }) }))); };
exports.default = SvgCertificate02;
